import React from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@one-thd/sui-atomic-components';

const SelectedFilter = (props) => {
  const { filterType, label, onClear } = props;

  const handleOnClick = (event) => {
    event.stopPropagation();
    onClear(label, filterType);
  };

  return (
    <Chip
      clickable
      label={(
        <>
          <span className="sui-font-bold sui-capitalize">{`${filterType}: `}</span> {label}
        </>
      )}
      role="listitem"
      onClick={handleOnClick}
      onDelete={handleOnClick}
      data-testid="selected-filter"
    />
  );
};

SelectedFilter.propTypes = {
  label: PropTypes.string.isRequired,
  filterType: PropTypes.string.isRequired,
  onClear: PropTypes.func
};

SelectedFilter.defaultProps = {
  onClear: () => {}
};

export default SelectedFilter;
